import {
  checkIsIdleFrom0To4Hours,
  checkIsIdleFrom10,
  checkIsIdleFrom4To10Hours,
} from "./checkAutoStatus";

export const getColorAutoByStatus = (status: number) => {
  if (checkIsIdleFrom0To4Hours(status)) return "#50BC46";
  if (checkIsIdleFrom4To10Hours(status)) return "#FDC52A";
  if (checkIsIdleFrom10(status)) return "#FF5630";
  return "#fff";
};
